/**
 * VendorProductAddOnService
 * Service for managing vendor product add-ons with view endpoints
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor product add-on CRUD operations with view endpoints
 */
export class VendorProductAddOnService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorProductAddOnService.DEFAULT_SERVICE_PATH,
            basePath: VendorProductAddOnService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all add-on views
     * @returns Array of add-on model views
     */
    async getViews() {
        const response = await this.getViewsRaw();
        return response.data ?? [];
    }
    /**
     * Get all add-on views with full response
     * @returns ResponseData with array of add-on model views
     */
    getViewsRaw() {
        const url = this.buildUrl('views');
        return this.http.get(url);
    }
    /**
     * Get add-on view by ID
     * @param id - AddOn ID
     * @returns Add-on model view
     */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data) {
            throw new Error(`Vendor product add-on view with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get add-on view by ID with full response
     * @param id - AddOn ID
     * @returns ResponseData with add-on model view
     */
    getViewRaw(id) {
        const url = this.buildUrl(`${id}/view`);
        return this.http.get(url);
    }
    /**
     * Get add-on views by product ID
     * @param productId - Product ID
     * @returns Array of add-on model views for the product
     */
    async getByProductId(productId) {
        const response = await this.getByProductIdRaw(productId);
        return response.data ?? [];
    }
    /**
     * Get add-on views by product ID with full response
     * @param productId - Product ID
     * @returns ResponseData with array of add-on model views
     */
    getByProductIdRaw(productId) {
        const url = this.buildUrl(`by-product/${productId}/views`);
        return this.http.get(url);
    }
    /**
     * Get add-on views by vendor ID
     * @param vendorId - Vendor ID
     * @returns Array of add-on model views for the vendor
     */
    async getByVendorId(vendorId) {
        const response = await this.getByVendorIdRaw(vendorId);
        return response.data ?? [];
    }
    /**
     * Get add-on views by vendor ID with full response
     * @param vendorId - Vendor ID
     * @returns ResponseData with array of add-on model views
     */
    getByVendorIdRaw(vendorId) {
        const url = this.buildUrl(`by-vendor/${vendorId}/views`);
        return this.http.get(url);
    }
}
VendorProductAddOnService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorProductAddOnService.BASE_PATH = 'api/vendor-product-add-ons';
//# sourceMappingURL=VendorProductAddOnService.js.map